import {FormattedMessage, MessageDescriptor} from 'react-intl';
import {Spinner, view, css} from '@sail/ui/deprecated';

import {TopicRoutingEndpointResponseSuccess} from '@stripe-internal/conversations-shared-dependencies';
import {selectorMessages} from './selectorMessages';
import {TopicSelect} from './TopicSelect';

import {useTopics} from './useTopics';

export type Topic = TopicRoutingEndpointResponseSuccess['topics'][number];

export type TopicMap = {
  [key in Topic]: {
    label: MessageDescriptor;
  };
};

type Props = {
  onSelectTopic: (topic?: Topic) => void;
  selectedTopic: Topic | null | undefined;
};

export function TopicSelector({
  onSelectTopic,
  selectedTopic,
}: Props): JSX.Element {
  const {topics} = useTopics();

  let field: React.ReactNode = null;

  if (topics) {
    field = (
      <view.div data-testid="TopicSelector">
        <TopicSelect
          data-testid="TopicSelector"
          topics={topics}
          onSelectTopic={onSelectTopic}
          selectedTopic={selectedTopic}
          width="maximized"
        />
      </view.div>
    );
  } else {
    field = <Spinner data-testid="TopicSelectorSpinner" />;
  }

  return (
    <label>
      <view.div
        data-testid="TopicSelectorGroup"
        css={{
          margin: 'medium',
          display: css.value('flex'),
          flexDirection: css.value('column'),
          rowGap: css.value('8px'),
        }}
      >
        <FormattedMessage {...selectorMessages.label} />
        {field}
      </view.div>
    </label>
  );
}
